import React from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import bgimg from '../../assets/images/bgimg.jpg';

function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center w-screen h-screen">
      <div className="px-4 lg:py-12">
        <div className="lg:gap-4 lg:flex">
          <div className="flex flex-col items-center justify-center md:py-24 lg:py-32">
            <h1 className="font-bold text-green-600 text-9xl">404</h1>
            <p className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
              ขออภัย ไม่พบหน้าที่คุณต้องการ
            </p>
            <p className="mb-8 text-center text-gray-500 md:text-lg">
              The page you’re looking for doesn’t exist.
            </p>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => {
                navigate('/', { replace: true });
              }}
            >
              <div className="text-white">กลับหน้าแรก</div>
            </Button>
          </div>
          <div className="invisible md:visible">
            <img src={bgimg} alt="img" className="object-cover w-full h-full" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
